import type { UserRelation } from '@/services/user'

export type UserRelationOption = {
  value: UserRelation
  /** Badge label shown next to a user's name for each relation they matched */
  label: string
  color: 'brand' | 'success' | 'warning'
}

export const USER_RELATION_OPTIONS: UserRelationOption[] = [
  { value: 'applicants', label: 'Sökande', color: 'warning' },
  { value: 'debtors', label: 'Låntagare', color: 'brand' },
  { value: 'customers', label: 'Kund', color: 'success' },
]
